  import BaseScene from "../../scenes/BaseScene";
  import { QuestionModel } from "../../interfaces/IContentModel";
  import { PHShape } from "../../plugins/global/PlaceholderPlugin";
  
  export default class FullScreenQuestionComponent extends Phaser.GameObjects
    .Container {
    background: Phaser.GameObjects.Image;
    model: QuestionModel;
    private onComplete: (correct: boolean) => void;
    scene: BaseScene;
  
    questionText: Phaser.GameObjects.Text;
    answersContainer: Phaser.GameObjects.Container;
    alertBg: Phaser.GameObjects.Graphics;
    bgs: Phaser.GameObjects.Image[] = [];
    submitButton: Phaser.GameObjects.Image;
    submitText: Phaser.GameObjects.Text;
    qSubmitted: boolean;
    _selected: number = -1;
  
    constructor(
      scene: BaseScene,
      questionModel: QuestionModel,
      onComplete: (correct: boolean) => void
    ) {
      super(scene, scene.cameras.main.centerX, scene.cameras.main.centerY);
      this.model = questionModel;
      
      this.scene = scene;
      this.onComplete = onComplete;
  
      // const blackout = scene.sponge.placeholder.image(
      //   scene,
      //   0,
      //   0,
      //   PHShape.RECT,
      //   {
      //     width: 608,
      //     height: 842,
      //     radius: 0,
      //   },
      //   0x000624
      // );
  
      // blackout.alpha = 0.8;
  
      // scene.add.tween({
      //   targets: blackout,
      //   alpha: 0.7,
      //   yoyo: true,
      //   delay: 1000,
      //   duration: 6000,
      // });
  
      this.background = scene.add.image(
        0,
        0,
        "runner-atlas",
        "question-background.png"
      );
  
     
  
      this.questionText = scene.add.text(
        0,
        -270,
        this.model.question,
        scene.sponge.data.model.fonts.questionFull
      );
  
      this.questionText.setOrigin(0.5, 0);


      
    if(this.model._voiceOver){
      this.scene.sponge.startVO(this.model._voiceOver,this.scene);
    }
  
      this.add([ this.background, this.questionText]);
  
      this.alertBg = scene.add.graphics();
      this.alertBg.fillStyle(0x740818, 0.8);
      this.add(this.alertBg);
  
       
      this.answersContainer = scene.add.container(0, 0);
      this.add(this.answersContainer);

      this.qSubmitted = false;
  
      this.populateAnswers();
  
      this.submitButton = scene.add.image(
        0,
        320,
        "runner-atlas",
        "submit-box.png"
      );
      this.submitButton.on("pointerup", () => {
        this.submitAnswer(
          this.model.answers[this._selected]._correct
        );
      });

      this.submitButton.on("pointerover", () => {
        this.submitButton.setFrame(this.qSubmitted ? "submit-active-hover.png":"submit-active.png")
      }); 

      this.submitButton.on("pointerout", () => {
        this.submitButton.setFrame(this.qSubmitted ? "submit-active.png":"submit-box.png")
      }); 

      this.submitText = scene.add.text(
        0,
        320,
        scene.sponge.data.model.content.strings.go,
        scene.sponge.data.model.fonts.answer
      );
      this.submitText.setOrigin(0.5);
      this.submitText.setAlpha(0.5);
  
      this.add([this.submitButton, this.submitText]);
  
  
      scene.add.existing(this);
    }
  
    populateAnswers() {
      this.bgs = [];
      for (let i = 0; i < this.model.answers.length; i++) {
        const ans = this.model.answers[i];
        const bg = this.scene.add.image(
          0,
          80 + i * 125,
          "runner-atlas",
          "answer.png"
        );
        bg.setData("isSelected", false);
  
        const text = this.scene.add.text(
          0,
          80 + i * 125,
          ans.text,
          this.scene.sponge.data.model.fonts.answer
        );
        text.setOrigin(0.5);
  
        this.bgs.push(bg);
        bg.setInteractive({ useHandCursor: true });
        bg.on("pointerup", () => {
          this.selectAnswer(i);
        });
        bg.on("pointerover", () => {
          bg.setFrame("answer-selected.png")

          // if(this.model._voiceOver){
          //   this.scene.sponge.startVO((i==0?"yes":"no"),this.scene);
          // }

          
        });
        bg.on("pointerout", () => {
          if(!bg.data.values.isSelected){bg.setFrame("answer.png")}
        });
  
        this.answersContainer.add([bg, text]);
      }
    }
  
    selectAnswer(index: number) {
      this._selected = index;
      this.qSubmitted = true;
  
      for (let i = 0; i < this.bgs.length; i++) {
        this.bgs[i].setTexture(
          "runner-atlas",
          i === index ? "answer-selected.png" : "answer.png" 
        );
        this.bgs[i].data.values.isSelected = (i === index) ? true : false;
      }
  
      this.submitButton.setTexture("runner-atlas", "submit-active.png");
      this.submitText.alpha = 1;
  
      this.submitButton.setInteractive({ useHandCursor: true });
    }
  
    submitAnswer(isCorrect: boolean) {
      console.log(isCorrect);

      //// trigger feedback if required - pull from this.model
      if(this.model.posFB){
        const tgt: string = isCorrect ? this.model.posFB : this.model.negFB;
        this.scene.sponge.popup.launchPopup(tgt, ()=> {
          this.onComplete(isCorrect);
          this.destroy();
          
        })
      }else{
        this.onComplete(isCorrect);
          this.destroy();
      }
      
          
     
      
    }
  
  
    update() {
      super.update();
    }
  }
  